import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processUnrepairedDamageData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
): BinderSectionData => {
  const processedUnrepairedDamageData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const hasUnrepairedDamage =
        vehicle?.is_unrepaired_damage !== undefined
          ? vehicle.is_unrepaired_damage
          : false;

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        hasUnrepairedDamage,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        isValid: !hasUnrepairedDamage,
      };
    }),
  };

  // Overall unrepaired damage validation
  const isUnrepairedDamageValid = processedUnrepairedDamageData.vehicles.every(
    (vehicle) => vehicle.isValid,
  );
  const unrepairedDamageMessage = !isUnrepairedDamageValid
    ? 'One or more vehicles have unrepaired damage.'
    : null;

  return {
    title: 'Unrepaired damage',
    description:
      'Do any of the vehicles on the application have unrepaired damage?',
    isValid: isUnrepairedDamageValid,
    message: unrepairedDamageMessage,
    data: processedUnrepairedDamageData,
  };
};
